import { SCREEN_NAME, HOMEPAGE_SCREEN_NAME } from '../constants'

export const formatPageName = (pageName: string): string | null => {
  if (typeof pageName !== 'string') {
    return null
  }
  return pageName === HOMEPAGE_SCREEN_NAME ? SCREEN_NAME : pageName
}
